
const CareCommentContentType = Symbol();

export class CareCommentContent {
    [CareCommentContentType]: any;
    readonly value: string;

    private constructor(careCommentContent: string) {
        this.value = careCommentContent;
    }

    static isInvalidSize(title: string): boolean {
        return title.length < 1 || title.length > 1000;
    }

    static messageInvalidSize(label: string): string {
        return `${label}は1文字以上1000文字以下で入力してください。`;
    }

    static fromString(careCommentContent: string): CareCommentContent {
        return new CareCommentContent(careCommentContent);
    }
}
